
export default function ProductLineup() {
  const inkjetProducts = [
    {
      name: 'HP OfficeJet Pro 9010',
      image: 'https://public.readdy.ai/ai/img_res/c2d76d3b134796cffbeb171ec1dbf5ab.jpg',
      features: ['カラー印刷', 'A4対応', 'WiFi対応'],
      speed: '22枚/分',
      monthlyVolume: '最大500枚/月',
      price: '月額 5,000円〜'
    },
    {
      name: 'Canon MAXIFY GX7030',
      image: 'https://readdy.ai/api/search-image?query=Canon%20MAXIFY%20printer%20professional%20product%20photo%2C%20white%20background%2C%20modern%20office%20inkjet%20printer%2C%20clean%20simple%20background%2C%20high%20quality%20product%20photography&width=400&height=300&seq=canon-gx7030-001&orientation=landscape',
      features: ['大容量タンク', 'A4対応', '自動両面印刷'],
      speed: '24枚/分',
      monthlyVolume: '最大1,000枚/月',
      price: '月額 6,500円〜'
    },
    {
      name: 'Epson EcoTank ET-5850',
      image: 'https://readdy.ai/api/search-image?query=Epson%20EcoTank%20printer%20professional%20product%20photo%2C%20white%20background%2C%20modern%20office%20inkjet%20printer%20with%20large%20ink%20tanks%2C%20clean%20simple%20background%2C%20high%20quality%20product%20photography&width=400&height=300&seq=epson-et5850-001&orientation=landscape',
      features: ['エコタンク', 'A4対応', 'スキャナー付'],
      speed: '25枚/分',
      monthlyVolume: '最大1,500枚/月',
      price: '月額 7,000円〜'
    }
  ];

  const laserProducts = [
    {
      name: 'Brother MFC-L3770CDW',
      image: 'https://readdy.ai/api/search-image?query=Brother%20laser%20printer%20professional%20product%20photo%2C%20white%20background%2C%20modern%20office%20color%20laser%20multifunction%20printer%2C%20clean%20simple%20background%2C%20high%20quality%20product%20photography&width=400&height=300&seq=brother-l3770-001&orientation=landscape',
      features: ['カラーレーザー', 'A4対応', '複合機'],
      speed: '25枚/分',
      monthlyVolume: '最大2,500枚/月',
      price: '月額 9,800円〜'
    },
    {
      name: 'Ricoh SP C261SFNw',
      image: 'https://readdy.ai/api/search-image?query=Ricoh%20laser%20printer%20professional%20product%20photo%2C%20white%20background%2C%20modern%20office%20color%20laser%20multifunction%20printer%2C%20clean%20simple%20background%2C%20high%20quality%20product%20photography&width=400&height=300&seq=ricoh-c261-001&orientation=landscape',
      features: ['高速印刷', 'A4対応', 'ネットワーク対応'],
      speed: '21枚/分',
      monthlyVolume: '最大3,000枚/月',
      price: '月額 12,000円〜'
    },
    {
      name: 'Xerox VersaLink C405',
      image: 'https://readdy.ai/api/search-image?query=Xerox%20VersaLink%20printer%20professional%20product%20photo%2C%20white%20background%2C%20modern%20office%20color%20laser%20multifunction%20printer%2C%20clean%20simple%20background%2C%20high%20quality%20product%20photography&width=400&height=300&seq=xerox-c405-001&orientation=landscape',
      features: ['業務用', 'A4対応', 'タッチパネル'],
      speed: '36枚/分',
      monthlyVolume: '最大5,000枚/月',
      price: '月額 15,000円〜'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            機種ラインナップ
          </h2>
          <p className="text-xl text-gray-600">
            用途に合わせて最適な機種をお選びいただけます
          </p>
        </div>

        {/* Inkjet Type */}
        <div className="mb-20">
          <div className="flex items-center justify-center mb-12">
            <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white px-8 py-4 rounded-full">
              <h3 className="text-2xl font-bold flex items-center gap-3">
                <i className="ri-printer-line text-3xl"></i>
                全インクジェットタイプ
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {inkjetProducts.map((product, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 border-gray-100 hover:border-blue-300"
              >
                <div className="bg-gray-50 p-6 h-64 flex items-center justify-center">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4">{product.name}</h4>
                  <div className="space-y-3 mb-6">
                    {product.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <i className="ri-check-line text-blue-600"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="border-t border-gray-200 pt-4 space-y-2">
                    <p className="text-sm text-gray-600">印刷速度: <strong>{product.speed}</strong></p>
                    <p className="text-sm text-gray-600">推奨月間印刷枚数: <strong>{product.monthlyVolume}</strong></p>
                    <p className="text-lg font-bold text-blue-600 mt-4">{product.price}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Laser Type */}
        <div>
          <div className="flex items-center justify-center mb-12">
            <div className="bg-gradient-to-r from-orange-500 to-orange-400 text-white px-8 py-4 rounded-full">
              <h3 className="text-2xl font-bold flex items-center gap-3">
                <i className="ri-printer-fill text-3xl"></i>
                通常レーザータイプ
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {laserProducts.map((product, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 border-gray-100 hover:border-orange-300"
              >
                <div className="bg-gray-50 p-6 h-64 flex items-center justify-center">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4">{product.name}</h4>
                  <div className="space-y-3 mb-6">
                    {product.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <i className="ri-check-line text-orange-500"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="border-t border-gray-200 pt-4 space-y-2">
                    <p className="text-sm text-gray-600">印刷速度: <strong>{product.speed}</strong></p>
                    <p className="text-sm text-gray-600">推奨月間印刷枚数: <strong>{product.monthlyVolume}</strong></p>
                    <p className="text-lg font-bold text-orange-500 mt-4">{product.price}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-8">
            ※表示価格は目安です。詳細な料金プランについてはお問い合わせください。
          </p>
          <a 
            href="#contact" 
            className="inline-block bg-blue-600 text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-blue-700 transition-all shadow-lg whitespace-nowrap"
          >
            機種について相談する
          </a>
        </div>
      </div>
    </section>
  );
}
